import store from '@/store'

export default [
  {
    path: '/subject-grading-ranges',
    name: 'subject-grading-range',
    meta: { requiresAuth: true },
    component: () => import('@/pages/subject-grading-range/index.vue')
  }
]
